module.exports = __webpack_public_path__ + "assets/certificate_pdf/MCEMicrosoft Technology Literacy for Educators_ICT_Exam 62-193_E782-2200.e90f8a3f.pdf";